import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UpdateUserNotificationPreferenceRequest } from './updateUserNotificationPreferenceRequest.types';

export async function updateUserNotificationPreference(
  preferenceId: string,
  payload: UpdateUserNotificationPreferenceRequest
): Promise<void> {
  await axiosInstance.put(
    `/client-profiles/notification-preference/${preferenceId}`,
    payload
  );
}